import { h, render, Component } from 'preact';

const W_TEXT_FOAM = 'w-text-foam';
class TextFoam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontSize: this.props.maxFontSize,
      maxWidth: this.props.maxWidth,
    };
  }

  render() {
    return (
      <span
        class={`${W_TEXT_FOAM} w-css-reset w-css-reset-tree`}
        style={{ ...this.textStyle(), ...this.props.style }}
        ref={(el) => (this.textContainer = el)}
      >
        {this.props.children}
      </span>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.maxWidth !== this.state.maxWidth) {
      this.setState({
        maxWidth: nextProps.maxWidth,
      });
    }
  }

  componentDidMount() {
    this.maybeUpdateFontSize();
  }

  componentDidUpdate() {
    this.maybeUpdateFontSize();
  }

  maybeUpdateFontSize() {
    const textContainerWidth = this.textContainer.clientWidth;
    // The width might be 0 at the beginning, and we don't want to divide by 0
    // when using textContainerWidth to compute nextFontSize.
    const nextFontSize = textContainerWidth
      ? Math.min(
          Math.max(
            this.props.minFontSize,
            (this.state.maxWidth / textContainerWidth) * this.state.fontSize,
          ),
          this.props.maxFontSize,
        )
      : this.props.maxFontSize;

    if (nextFontSize.toPrecision(2) !== this.state.fontSize.toPrecision(2)) {
      this.setState({
        fontSize: nextFontSize,
      });
    } else if (this.props.onFitted) {
      // We're not going to change the size again. We're done! Let the parent
      // component know.
      this.props.onFitted();
    }
  }

  textStyle() {
    return {
      fontSize: `${this.state.fontSize}px`,
      whiteSpace: 'pre',
    };
  }
}

export default TextFoam;
